import * as React from "react";
import { ChangeEvent } from "react";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { DocumentWithExpiryAnswer, HRQuestion } from "../../messages/HR";
import { GenericInputHeader } from "./GenericInputHeader";
import "./GenericDocumentInput.css";
import { GenericDateInput } from "./GenericDateInput";
import { isLoading, loading, Loading } from "../../Loading";
import { LocalDate } from "js-joda";
import { PlaceholderEmbeddedPDF } from "../placeholders/PlaceholderEmbeddedPDF";
import { MultipleImagesSelect } from "../widgets/MultipleImagesSelect";

interface GenericDocumentWithExpiryInputProps {
    hrDocumentWithExpiryQuestionWithStatus: HRQuestionWithStatus<HRQuestion.DocumentWithExpiryQuestion>;
    isHidden: boolean;
    onChange: (newVal: DocumentWithExpiryAnswer | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

interface GenericDocumentWithExpiryInputState {
    documentType: "PDF" | "Image";
}

export class GenericDocumentWithExpiryInput extends React.Component<GenericDocumentWithExpiryInputProps, GenericDocumentWithExpiryInputState> {
    constructor(props: GenericDocumentWithExpiryInputProps) {
        super(props);

        let docType: "Image" | "PDF" = "Image";
        const ans = this.props.hrDocumentWithExpiryQuestionWithStatus.question.answer;
        if (ans && this.getUrlExtension(ans.document) === "pdf") {
            docType = "PDF";
        }
        this.state = {
            documentType: docType
        };
    }

    handlePhotoChange(event: ChangeEvent<HTMLInputElement>, questionId: HRQuestionId) {
        if (event.target.files === null || event.target.files.length === 0) {
            this.props.onChange(null, questionId);
            this.props.onBlur(questionId);
        } else {
            const reader = new FileReader();
            this.setState({
                documentType: (event.target.files[0].type === "application/pdf") ? "PDF" : "Image"
            });
            reader.onload = () => {
                this.props.onChange({ document: (reader.result as string), expiryDate: null }, questionId);
                this.props.onBlur(questionId);
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    getDisplayStatus(answer: DocumentWithExpiryAnswer | null, status: boolean | null | Loading) {
        return answer === null ? status : (isLoading(status) ? loading() : answer !== null);
    }

    getUrlExtension(url: string): string {
        const ext = url.split(/\#|\?/)[0].split(".").pop();
        if (!ext) {
            return "";
        }
        return ext.trim();
    }

    renderImage(url: string) {
        return (
            <div
                style={{
                    background: `url(${url}) center / contain no-repeat`
                }}
                className={"GenericDocumentInput__fileUploadPreview"}
            />
        );
    }

    renderPdf(url: string) {
        return (
            <div id="GenericDocumentWithExpiryInput_pdfContainer">
                <PlaceholderEmbeddedPDF
                    pdfUrl={url}
                    containerElementId={"GenericDocumentWithExpiryInput_pdfContainer"}
                    widthScale={0.4}
                />
            </div>
        );
    }

    setDocumentType(docType: "Image" | "PDF") {
        this.setState({documentType: docType});
    }

    render() {
        const question = this.props.hrDocumentWithExpiryQuestionWithStatus.question;
        const status = this.props.hrDocumentWithExpiryQuestionWithStatus.status;

        // THIS IS FOR BACKWARDS COMPTAIBLTY
        if (question.answer !== null && question.answer.expiryDate !== null) {
            try {
                LocalDate.parse(question.answer.expiryDate);
            } catch (e) {
                const temp = new Date(question.answer.expiryDate);
                let monthPrefix = "";
                let dayPrefix = "";
                if (temp.getMonth() < 10) {
                    monthPrefix = "0";
                }
                if (temp.getDay() < 10) {
                    dayPrefix = "0";
                }
                question.answer.expiryDate = temp.getFullYear() + "-" + monthPrefix + (temp.getMonth() + 1) + "-" + dayPrefix + temp.getDate();
            }
        }
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader
                    status={status}
                    questionText={question.questionText}
                />
                <MultipleImagesSelect
                    onSetDocumentType={(type: "Image" | "PDF") => this.setDocumentType(type)}
                    uploadPdf={(imagePdf) => {
                        const questionId = question.id;
                        this.props.onChange({ document: imagePdf, expiryDate: null }, questionId);
                        this.props.onBlur(questionId);
                    }
                    }
                />
                {question.answer !== null && question.answer.document !== null ?
                    <div>
                        {this.state.documentType === "PDF" ? this.renderPdf(question.answer.document) : this.renderImage(question.answer.document)}
                        <GenericDateInput
                            hrDateQuestion={{
                                question: {
                                    type: "FullDate",
                                    id: question.id,
                                    parentId: question.parentId,
                                    parentAnswer: question.parentAnswer,
                                    isHidden: question.isHidden,
                                    answer: question.answer.expiryDate,
                                    isMandatory: false,
                                    questionText: "Expiration Date:",
                                    textId: question.textId
                                },
                                status: status
                            }}
                            onMobile={false}
                            isHidden={question.isHidden}
                            onChange={(newVal, id) => this.props.onChange({
                                // TODO remove any cast
                                document: (question.answer as any).document,
                                expiryDate: newVal === null ? null : newVal.toString()
                            }, id)}
                            onBlur={(id) => this.props.onBlur(id)}
                        />
                    </div>
                    : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericDocumentWithExpiryInput.tsx